<template>
    <div class="selected-fabric" v-if="fabric">
        <img :src="fabric.detailedImage || fabric.mainImage"
             :alt="fabric.name"
             :title="fabric.name"
        >
        <slot></slot>
        <template v-if="!hideHeading">
            <h5 class="heading heading-smaller">{{ $tr.selectedFabricPreview }}
                <HoverInfo :text="fabric.name"/>
            </h5>
        </template>
    </div>
</template>

<script>
import HoverInfo from "./HoverInfo";

export default {
    name: "SelectedFabric",
    props: [
        'hideHeading'
    ],
    components: {
        HoverInfo
    },
    computed: {
        fabric() {
            return this.$db.products.fabrics;
        }
    }
}
</script>
